{
  "all-listings": {
    "disconnected": {
      "text": "Crea tu cuenta o inicia sesión para ver los recursos disponibles en la red Partage Agricole."
    },
    "needLogin": {
      "secondLine": "Crea tu cuenta o inicia sesión para ver los recursos disponibles en la red Partage Agricole."
    },
    "empty": {
      "offer": {
        "firstLine": "¡Comienza tu aventura aquí!",
        "primaryButtonText": "¡Publica una oferta!",
        "secondLine": "Participa en el catálogo ofreciendo objetos para prestar."
      }
    }
  },
  "common": {
    "appName": "Partage Agricole",
    "appDownloadPrompt": {
      "guest": "¿Te gusta lo que ves? Lleva Partage Agricole en tu teléfono y recibe nuevas disponibilidades cerca de ti",
      "qrCodeAccessibilityLabel": "Código QR para descargar la aplicación Partage Agricole"
    }
  },
  "contact-information": {
    "prompt": "Agrega el código postal de la empresa para ver qué objetos están disponibles en los alrededores.",
    "title": "Tu dirección",
    "prompt-public": "Agrega tu código postal para ver los anuncios disponibles en los alrededores.",
    "title-public": "Tu código postal"
  },
  "contact-us": {
    "firstParagraph": "El servicio a los miembros de Partage Agricole está disponible por correo electrónico y mensajería. Te responderemos lo más rápido posible.",
    "faqLink": "https://www.partageagricole.ca/faq",
    "chatPrompt": {
      "bugReport": "¡Hola! 😊\n\nGracias por explicarnos qué está fallando.",
      "suggestion": "¡Hola! 😊\n\nSiempre estamos abiertos a sugerencias. Gracias por ayudarnos a mejorar nuestro servicio.\n\n¡Gracias!"
    }
  },
  "credentials": {
    "activationCodeFieldHelp": "Solo los socios de Partage Agricole pueden usar esta aplicación. Para obtener el código de invitación, contacta a <a>Partage Agricole</a>.",
    "activationCodeFieldHelpLink": "https://www.partageagricole.ca/s-inscrire"
  },
  "guidelines": {
    "fifthParagraph": "No utilizar Partage Agricole para vender objetos."
  },
  "impact": {
    "levels": {
      "0": {
        "description-completed": "Se unió a Partage Agricole",
        "title": "Explorador"
      }
    }
  },
  "introModal": {
    "title": "Estimado/a {{name}},",
    "first": "¡Gracias por unirte a la comunidad y dar un primer paso hacia la reducción de tu consumo y la creación de nuevos lazos!",
    "second": "<strong>Compartir es una muestra de confianza</strong>: ¡cuanto más prestes, más ganas tendrán los demás de prestarte!",
    "third": "<strong>Sabe que menos del 0,1 % de todos los intercambios</strong> generan un daño. Y no es por mala fe. Es simplemente normal cuando los objetos se usan un poco más."
  },
  "my-information": {
    "firstNameFieldLabel": "Nombre de la empresa",
    "credentialInformationTitle": "Cuenta y seguridad",
    "personalInformationTitle": "Información del perfil"
  },
  "my-personal-information": {
    "firstNameFieldLabel": "Nombre de la empresa",
    "firstNameFieldPlaceholder": "ej. Granja de la Torre de Plata",
    "title": "Información del perfil"
  },
  "my-plan": {
    "businessPlan": {
      "firstParagraph": {
        "enterprise": "Tu suscripción a esta aplicación de mutualización es cortesía de Partage Agricole."
      },
      "title": {
        "enterprise": "Suscripción Partage Agricole"
      }
    },
    "noEnd": "Esta suscripción es válida mientras seas miembro de Partage Agricole."
  },
  "new": {
    "itemInformationSection": {
      "nameFieldPlaceholder": "ej: Tractor de jardín",
      "descriptionFieldPlaceholder": {
        "offer": "Marca, dimensiones, color, peso, estado, año de adquisición, condiciones de préstamo, especificidades del objeto...",
        "request": "Marca, dimensiones, color, peso, estado, año de adquisición, condiciones de préstamo, especificidades del objeto..."
      }
    }
  },
  "notifications": {
    "introModal": {
      "intro": {
        "title": "Bienvenido/a al Club",
        "body": "¡Descubre Partage Agricole!"
      }
    },
    "welcome": "¡Bienvenido/a a Partage Agricole!",
    "welcomeMessage": "Gracias por confiar en nosotros.",
    "rate": {
      "borrower": {
        "message": "Tu opinión es importante para nosotros y para los otros miembros de Partage Agricole."
      },
      "lender": {
        "message": "Tu opinión es importante para nosotros y para los otros miembros de Partage Agricole."
      }
    }
  },
  "offerAvailability": {
    "refrainPopup": {
      "hi": "Estimado miembro,",
      "text": {
        "lender": {
          "before": "No olvides reservar tus fechas de trabajo y planificar tus días de transporte durante tu reserva.",
          "after": "No olvides reservar tus fechas de trabajo y planificar tus días de transporte."
        },
        "borrower": "No olvides planificar tus días de transporte durante tu préstamo."
      }
    }
  },
  "one-listing": {
    "needFoundModal": {
      "step2": {
        "gotoSelectLender": "La necesidad fue cubierta en Partage Agricole"
      }
    }
  },
  "personal-information": {
    "firstNameFieldLabel": "Nombre de la empresa",
    "firstNameFieldPlaceholder": "ej. Granja de la Torre de Plata",
    "pictureFieldSubtitle": "Esta imagen se mostrará en tus anuncios y tu perfil.",
    "pictureFieldTitle": "Agregar una imagen del logo de la empresa",
    "title": "Información del perfil",
    "firstNameFieldLabel-public": "Nombre",
    "firstNameFieldPlaceholder-public": "Nombre",
    "lastNameFieldLabel-public": "Apellido",
    "lastNameFieldPlaceholder-public": "Apellido",
    "phoneFieldLabel-public": "Número de teléfono (opcional)",
    "pictureFieldSubtitle-public": "La foto de perfil aumenta la confianza entre miembros",
    "pictureFieldTitle-public": "Agregar una foto de perfil",
    "title-public": "Tu información personal"
  },
  "privacy": {
    "link1": "https://www.partageagricole.ca/termes-et-conditions",
    "link2": "https://www.partage.club/politique-de-confidentialite",
    "line3": "de Partage Agricole."
  },
  "quick-new-thanks": {
    "bodyText": "¡Acabas de contribuir a enriquecer el catálogo de <strong>Partage Agricole</strong>!\n\nPuedes modificar tus ofertas en cualquier momento en tu centro de intercambios."
  },
  "ratings": {
    "notGreat": {
      "ctaButton": "Contactar a Partage Agricole"
    }
  },
  "tutorial": {
    "multipleOffers": {
      "step1": {
        "text": "Al ofrecer tus objetos, animas incluso a los horticultores más tímidos a pedir."
      }
    }
  }
}
